import React from "react";
import { VereadoresPage } from "./vereadores.page";
import { PresencasSessaoPage } from "./presencas-sessao.page";
import {
  AtividadesParlamentaresPage,
  AtosNormativosPage,
  ComissoesPage,
  CotasParlamentaresPage,
  ProjetosLeiPage,
  PrestacoesContaExecutivoPage,
  SessoesLegislativasPage,
  VotacoesNominaisPage,
} from "./camara-pages";

// Fonte única das telas públicas da Câmara. "path" é o endereço oficial (o mesmo usado no menu do SGAP);
// "aliases" cobre variações que quem cadastra o menu naturalmente digita, para o link nunca cair em "página não existe".
// Para uma tela nova: criar a página, acrescentar uma linha aqui e o endereço na lista de ajuda do cadastro de menus (SGAP).
export const camaraRoutes: { path: string; aliases: string[]; element: React.ReactElement }[] = [
  { path: "/vereadores", aliases: ["/vereador"], element: <VereadoresPage /> },
  { path: "/sessoes-legislativas", aliases: ["/sessoes", "/sessao-legislativa", "/sessoes-legislativa"], element: <SessoesLegislativasPage /> },
  {
    path: "/presencas-sessao",
    aliases: ["/presenca-em-sessoes", "/presencas-em-sessoes", "/presenca-sessao", "/presenca-sessoes", "/presencas-sessoes", "/presenca-nas-sessoes", "/presencas"],
    element: <PresencasSessaoPage />,
  },
  { path: "/projetos-lei", aliases: ["/projetos-de-lei", "/projeto-de-lei", "/projeto-lei"], element: <ProjetosLeiPage /> },
  { path: "/atos-normativos", aliases: ["/ato-normativo", "/atos"], element: <AtosNormativosPage /> },
  { path: "/votacoes-nominais", aliases: ["/votacoes", "/votacao-nominal", "/votacao"], element: <VotacoesNominaisPage /> },
  { path: "/cotas-parlamentares", aliases: ["/cota-parlamentar", "/cotas", "/cota-parlamentares"], element: <CotasParlamentaresPage /> },
  { path: "/atividades-parlamentares", aliases: ["/atividade-parlamentar", "/atividades", "/atividade-parlamentares"], element: <AtividadesParlamentaresPage /> },
  { path: "/comissoes", aliases: ["/comissao"], element: <ComissoesPage /> },
  {
    path: "/prestacoes-conta-executivo",
    aliases: ["/prestacao-contas-executivo", "/prestacao-de-contas-do-executivo", "/prestacoes-contas-executivo", "/prestacao-conta-executivo"],
    element: <PrestacoesContaExecutivoPage />,
  },
];
